import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const SectionHeading = ({ title, subtitle, linkTo, linkLabel, testId }) => (
  <div className="flex items-end justify-between mb-8">
    <div>
      <h2 className="text-3xl md:text-4xl font-black tracking-tight text-[#1A1A1A]" data-testid={testId}>{title}</h2>
      {subtitle && <p className="text-[#7A7468] mt-2">{subtitle}</p>}
    </div>
    {linkTo && (
      <Link to={linkTo} className="hidden md:inline-flex text-sm font-semibold text-[#0F8B5C] hover:underline items-center gap-1">
        {linkLabel} <ArrowRight className="w-4 h-4" />
      </Link>
    )}
  </div>
);

export const IconFeature = ({ icon: Icon, title, desc, dark = false }) => (
  <div className={dark ? 'flex gap-4' : 'p-6 rounded-2xl bg-white border border-[#EFEAE0] hover:shadow-lg transition-shadow'}>
    <div className={`w-11 h-11 rounded-xl flex items-center justify-center shrink-0 ${dark ? 'bg-white/15 backdrop-blur' : 'bg-[#0F8B5C]/10 mb-4'}`}>
      <Icon className={`w-5 h-5 ${dark ? 'text-[#F2B441]' : 'text-[#0F8B5C]'}`} />
    </div>
    <div>
      <h3 className={`font-bold ${dark ? 'text-lg text-white' : 'text-[#1A1A1A]'}`}>{title}</h3>
      <p className={`text-sm mt-1 leading-relaxed ${dark ? 'text-white/80' : 'text-[#7A7468]'}`}>{desc}</p>
    </div>
  </div>
);
